<template>
  <header class="zui-header">
    <div class="headerLeft">
      <logo type="dpcloud" href="/"></logo>
      <h4 class="zui-logo-text">
        |&nbsp;&nbsp;贴近摄影测量超精细真三维
        <br />
        |&nbsp;&nbsp;数据·软件·服务
      </h4>
    </div>
    <div class="headerRight">
      <div class="zui-rightcol"><span @click="openMenu">◄目录►</span></div>
      <drop-list :config="configData" ref="droplist"></drop-list>
      <div class="zui-login">
        <div class="trial" @click="getTrial" v-show="showBtn">
          <img class="trialImg" src="../assets/img/礼物.png" alt="" />
          <p class="trialText">
            免费试用
          </p>
        </div>
        <p v-if="!$store.state.token" class="login" @click="gologin">登录</p>
        <el-popover v-else placement="right" width="240" trigger="hover">
          <div class="login-information">
            <div style="display: flex; justify-content:flex-start;">
              <img
                :src="$store.state.userData.avatar"
                alt=""
                width="40px"
                height="40px"
                style="border-radius: 30px;"
              />
              <span style="margin: 10px ;">{{
                $store.state.userinfo.nickname
              }}</span>
            </div>
            <hr style="margin: 15px 0;" />
            <p>我的订单</p>
            <span style="color: #00aaff ; cursor: pointer;" @click="QueryOrder"
              >查询您的消费订单</span
            >
            <hr style="margin: 15px 0;" />
            <p>账号设置</p>
            <span
              style="color: #00aaff ; cursor: pointer;"
              @click="AccountSettings"
              >设置头像，姓名，用户名等</span
            >
            <!-- <hr style="margin: 15px 0;" /> -->
            <!--          <p>实名认证（未认证）</p>
          <span style="color: #00aaff ; cursor: pointer;" @click="realname">认证获得更多权益</span> -->
            <hr style="margin: 15px 0;" />
            <p>账号类型</p>
            <!-- <el-radio v-model="radio" label="1">团队</el-radio> -->
            <el-radio v-model="radio" label="2">个人</el-radio>
            <hr style="margin: 15px 0;" />
            <p style="padding: 10px;  cursor: pointer;" @click="Logout">
              退出登录
            </p>
          </div>
          <p slot="reference">
            <i class="el-icon-s-custom"></i>
            {{ $store.state.userinfo.nickname }}
          </p>
        </el-popover>
      </div>
      <zui-button :list="navList" @click="onButtonClick"></zui-button>
    </div>
  </header>
</template>
<script>
import "./less/header.less";
import Logo from "./Logo";
import ZuiButton from "../components/Button";
import DropList from "vue-droplist";
import router from "../router/index";
export default {
  props: {
    logoType: {
      default: "zhichou"
    }
  },
  components: { Logo, ZuiButton, DropList },
  data() {
    return {
      radio: "2",
      configData: {
        position: {
          // 设置显示位置，position
          top: "60px",
          right: "15px",
          bottom: "",
          left: ""
        },
        width: "40%", // 设置宽度
        list: [
          // 设置下拉列表数据和对应的点击事件
          { text: "首页", action: this.gohome },
          { text: "资讯中心", action: this.goinformation },
          { text: "解决方案", action: this.gosolution },
          // { text: "定价", action: this.gopricing },
          { text: "产品中心", action: this.goproduct },
          { text: "人才招聘", action: this.gorecruitment },
          { text: "下载中心", action: this.godownload },
          { text: "关于我们", action: this.goaboutus },
          { text: "登录", action: this.gologin }
        ]
      },
      navList: [
        { text: "关于我们", router: "aboutus" },
        { text: "下载中心", router: "download" },
        { text: "人才招聘", router: "recruitment" },
        { text: "产品中心", router: "product" },
        // { text: "定价", router: "pricing" },
        { text: "解决方案", router: "solution" },
        { text: "资讯中心", router: "information" },
        { text: "首页", router: "home" }
      ],
      showBtn: true
    };
  },
  mounted() {
    if (this.$store.state.token) {
      this.configData.list[8] = { text: "退出登录", action: this.Logout };
    }
  },
  watch: {
    $route() {
      if (this.$route.path == "/product/freetrial") {
        this.showBtn = false; /*判断在免费试用界面就隐藏免费试用按钮 */
      } else {
        this.showBtn = true;
      }
    }
  },
  methods: {
    onButtonClick: function(e) {
      if (e == "home") {
        this.$router.push({ path: "/" });
      } else if (e == "information") {
        this.$router.push({ path: "/information/informationlist" });
      } else if (e == "solution") {
        this.$router.push({ path: "/solution" });
      } else if (e == "product") {
        this.$router.push({ path: "/product" });
      } else if (e == "recruitment") {
        this.$router.push({ path: "/recruitment" });
      } else if (e == "download") {
        this.$router.push({ path: "/download/software" });
      } else {
        this.$router.push({ path: "/aboutus" });
      }
    },

    openMenu: function() {
      this.$refs.droplist.show();
    },
    gohome: function() {
      this.$router.push({ path: "/" });
    },
    goinformation: function() {
      this.$router.push({ path: "/information/informationlist" });
    },
    gosolution: function() {
      this.$router.push({ path: "/solution" });
    },
    // gopricing: function() {
    //   this.$router.push({ path: "/pricing" });
    // },
    goproduct: function() {
      this.$router.push({ path: "/product" });
    },
    gorecruitment: function() {
      this.$router.push({ path: "/recruitment" });
    },
    godownload: function() {
      this.$router.push({ path: "/download/software" });
    },
    goaboutus: function() {
      this.$router.push({ path: "/aboutus" });
    },
    gologin: function() {
      this.$router.push({ path: "/login" });
    },
    QueryOrder: function() {
      this.$router.push({ path: "/homepage/order" });
    },
    AccountSettings: function() {
      this.$router.push({ path: "/homepage/personaldata" });
    },
    realname: function() {
      this.$router.push({ path: "/homepage/realname" });
    },
    Logout: function() {
      const Token = this.$store.state.token;
      if (Token) {
        this.$confirm("此操作将退出当前账号, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$message({
              type: "success",
              message: "已退出当前账号!"
            });
            this.$store.commit("gettoken", ""); /*退出登录清除token*/
            this.$store.commit("getUserData", {}); /*退出登录清除UserData*/
            this.$store.commit("getUserinfo", {}); /*退出登录清除UserInfo*/
            this.$router.push("/login");
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消退出"
            });
          });
      } else {
        console.log(11);
        this.$message({
          type: "warning",
          message: "未登录!"
        });
      }
    },
    // 点击免费试用
    getTrial() {
      // this.$message.info("抱歉，该功能还在施工");
      // return;
      const token = this.$store.state.token;
      if (token === "") {
        this.$confirm("该操作需要登录才能进行，跳转到登录页吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$router.push({
              path: "/login",
              query: {
                redirect: "/product/freetrial"
              }
            }); /*跳转登录界面 */
          })
          .catch(() => {
            return;
          });
      } else {
        this.$router.push({
          path: "/product/freetrial" /*跳转到免费试用 */
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Header.vue